/**
 * Tools 列表卡片封面图配置
 * images 长度为 2：左 before / 右 after
 * images 长度为 3：左 / 中 / 右（如 AI 换装：衣服 + 人物 + 结果）
 */
var TOOL_DEMO_IMAGES = {
  'watermark-remover': {
    images: [
      require('@/assets/images/remove_full_watermark.jpg'),
      require('@/assets/images/remove_full_watermark2.jpg')
    ]
  },
  'background-remover': {
    images: [
      require('@/assets/images/remove_background.png'),
      require('@/assets/images/remove_background2.png')
    ]
  },
  'background-blur': {
    images: [
      require('@/assets/images/background_blur1.png'),
      require('@/assets/images/background_blur2.png')
    ]
  },
  'white-background': {
    images: [
      require('@/assets/images/white_background.jpg'),
      require('@/assets/images/white_background2.jpg')
    ]
  },
  'blue-background': {
    images: [
      require('@/assets/images/blue_background.jpg'),
      require('@/assets/images/blue_background2.jpg')
    ]
  },
  'photo-restore': {
    images: [
      require('@/assets/images/re_lod_photo.png'),
      require('@/assets/images/re_lod_photo2.png')
    ]
  },
  'blurry-photo-repair': {
    images: [
      require('@/assets/images/fix_blurry_images.png'),
      require('@/assets/images/fix_blurry_images2.jpg')
    ]
  },
  'cartoon-digital-human': {
    images: [
      require('@/assets/images/cartoons_anime.png'),
      require('@/assets/images/cartoons_anime2.jpg')
    ]
  },
  'manga-digital-human': {
    images: [
      require('@/assets/images/comic_digital_person.png'),
      require('@/assets/images/comic_digital_person2.jpg')
    ]
  },
  'oil-painting-digital-human': {
    images: [
      require('@/assets/images/oil_painting_human.jpeg'),
      require('@/assets/images/oil_painting_human2.jpg')
    ]
  },
  'id-photo-generator': {
    images: [
      require('@/assets/images/photo_id_gen.png'),
      require('@/assets/images/photo_id_gen2.jpg')
    ]
  },
  'ai-change-clothes': {
    images: [
      require('@/assets/images/outfit_change.png'),
      require('@/assets/images/outfit_change2.png'),
      require('@/assets/images/outfit_change3.png')
    ]
  },
  'face-swap': {
    images: [
      require('@/assets/images/tool-demos/face-swap-target.webp'),
      require('@/assets/images/tool-demos/face-swap-source.webp'),
      require('@/assets/images/tool-demos/face-swap-result.webp')
    ]
  },
  'ai-text-remover': {
    images: [
      require('@/assets/images/ai_remove_text.jpg'),
      require('@/assets/images/ai_remove_text2.jpg')
    ]
  },
  'ai-logo-remover': {
    images: [
      require('@/assets/images/ai_remove_logo.png'),
      require('@/assets/images/ai_remove_logo2.jpg')
    ]
  },
  'ai-passersby-remover': {
    images: [
      require('@/assets/images/remove_pedestrians.png'),
      require('@/assets/images/remove_pedestrians2.jpg')
    ]
  },
  'doc-crop-enhance': {
    images: [
      require('@/assets/images/doc-crop-before.png'),
      require('@/assets/images/doc-crop-after.png')
    ]
  },
  'handwritten-erase': {
    images: [
      require('@/assets/images/handwritten-before.png'),
      require('@/assets/images/handwritten-after.png')
    ]
  },
  'image-eraser': {
    images: [
      require('@/assets/images/image-eraser1.jpg'),
      require('@/assets/images/image-eraser2.png')
    ]
  },
  'object-remover': {
    images: [
      require('@/assets/images/tool-demos/object-remover-before.webp'),
      require('@/assets/images/tool-demos/object-remover-after.webp')
    ]
  },
  'ai-person-remover': {
    images: [
      require('@/assets/images/ai_person_remover1.png'),
      require('@/assets/images/ai_person_remover2.png')
    ]
  },
  'cartoon-video-style-converter': {
    images: [
      require('@/assets/images/ai_video_cartoon.mp4'),
      require('@/assets/images/ai_video_cartoon2.mp4')
    ]
  },
  'anime-video-style-converter': {
    images: [
      require('@/assets/images/ai_video_anime.mp4'),
      require('@/assets/images/ai_video_anime2.mp4')
    ]
  },
  'oil-painting-video-style-converter': {
    images: [
      require('@/assets/images/ai_video_oil_painting.mp4'),
      require('@/assets/images/ai_video_oil_painting2.mp4')
    ]
  },
  'cyberpunk-video-style-converter': {
    images: [
      require('@/assets/images/ai_video_cyberpunk.mp4'),
      require('@/assets/images/ai_video_cyberpunk2.mp4')
    ]
  }
}

export function getToolDemoImages(toolId) {
  var entry = TOOL_DEMO_IMAGES[toolId]
  if (!entry || !entry.images || !entry.images.length) return null
  return entry.images
}

export default TOOL_DEMO_IMAGES
